<template>
	<div class="wrap" :class="[size]" @click.stop="toVideo">
		
		<div class="c-video" :style="{'height': height+'px'}">
			<img v-if="cover" class="cover" :src="cover" :style="{'width': '100%', 'height': '100%'}" >
			<div class="c-video-mask">
				<div class="c-video-mask-play">
					<img src="@/static/images/my/videoPlay.png" alt="">
				</div>
				<!-- <div class="c-video-mask-duration">
					{{ duration }}
				</div> -->
			</div>
			
			<video @canplay="getDuration" :src="videoSrc" ref="testVideo" :width="width" :height="height" controls x-webkit-airplay="allow" x5-playsinline="" webkit-playsinline="" playsinline="true" >
				<!-- <source  type="video/mp4" /> -->
				您的浏览器不支持 HTML5 video 标签。
				
			</video>
		</div>
		
		<div class="c-videoTitle no-wrap-2" v-if="content">
			{{content}}
		</div>
		
	</div>
</template>

<script>
	/* eslint-disable */
	export default {
		props: {
			width: {
				type: Number,
				default: 180
			},
			height: {
				type: Number,
				default: 120
			},
			videoSrc: {
				type: String,
				default: ''
			},
			content: {
				type: String,
				default: '-'
			},
			// 尺寸
			size: {
				type: String,
				default: () => {
					return 'small'
				}
			},
			// 封面
			cover: {
				type: String,
				default: ''
			},
			id: {
				type: [Number, String],
				default: ''
			},
			is_link: {
				type: [Number, String],
				default: 0
			},
			type: {
				type: [Number, String],
				default: 0
			}
		},
		computed: {
		},
		data() {
			return{
				duration: ''
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			getDuration() {
				// let duration = Math.floor(this.$refs.testVideo.duration)
				// console.log(duration)
				// let duration_h = Math.floor(duration / 60 / 60)
				// let duration_m = Math.floor((this.duration - duration_h * 60 * 60)/60)
				// duration_m = duration_m < 10 ? '0' + duration_m : duration_m
				// let duration_s = duration % 60
				// duration_s = duration_s < 10 ? '0' + duration_s : duration_s
				// this.duration = duration_h + ':' + duration_m + ':' + duration_s
			},
			toVideo() {
				if (this.is_link == 1) {
					location.href = this.videoSrc
					return
				}
				this.$router.push({'name': 'video', query: {id: this.id, type: this.type, src: this.videoSrc}})
			}
		}
	}
</script>

<style scoped lang="stylus">
.wrap
	&.big
		width 360px
	&.small
		width 334px
.c-video
	position relative
	width 100%
	.cover
		position absolute
		top 0
		left 0
		z-index 1
		border-radius: 10px;
	video
		object-fit: fill;
		border-radius 10px
		width 100%
	.c-video-mask
		position absolute
		width 100%
		height 100%
		// background: rgba(0, 0, 0, 0.5)
		border-radius: 10px;
		z-index 1000
		.c-video-mask-play
			margin 60px auto 0 auto
			width 70px
			height 70px
			img
				width 100%
				height 100%
		.c-video-mask-duration
			margin-top 8px
			width 100%
			text-align center
			font-size: 28px;
			font-weight: bold;
			color: #FFFFFF;
.c-videoTitle
	margin-top 16px
	width 100%
	height: 74px;
	font-size: 26px;
	font-weight: bold;
	color: #111111;
	text-align center
</style>
